import { Form } from "antd";
import Button from "components/BaseWidgets/button";
import Modal from "components/BaseWidgets/modal";
import "./style.scss";
import OtpInput from "components/BaseWidgets/form/otp";
import { useEffect, useState } from "react";
import { usePreRegister, usePreRegisterOtpVerify } from "hooks/api/useAuth";

function OtpModal({
  open,
  onCancel,
  title,
  onSuccess,
  formData,
  isLoading,
  onSubmit,
  onResend,
  fieldSelection,
}) {
  const isMobileField = fieldSelection === 1;
  const { mutate: register, isPending: isResendPending } = usePreRegister({
    onSuccess: () => {
      setCounter(130);
    },
  });

  const { mutate: verifyOtp, isPending: isOtpPending } =
    usePreRegisterOtpVerify({
      onSuccess: () => {
        onSuccess();
      },
    });

  const [otpValue, setOtpValue] = useState("");
  const [form] = Form.useForm();
  const [counter, setCounter] = useState(130);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOtpValue("");
        form.resetFields();
        setCounter(130)
      }, 0)
    }
  }, [open]);

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => {
        setCounter((prev) => prev - 1);
      }, 1000);

    return () => clearInterval(timer);
  }, [counter]);

  const formatTime = () => {
    const minutes = Math.floor(counter / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (counter % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const handleResend = () => {
    const formFields = {
      identifier: formData.contact,
      name: formData.name,
      profile_for: formData.profileFor,
    };
    if (formData?.Countrycodes && isMobileField) {
      formFields.countrycode = formData.Countrycodes.value;
    }
    if (onResend) {
      onResend(formData.contact);
      return;
    }
    register(formFields);
  };

  const onFinish = (value) => {
    if (otpValue.length < 6) {
      form.setFields([
        {
          name: "otp",
          errors: ["Please enter the complete 6-digits OTP"],
        },
      ]);
      return;
    }

    const formFields = {
      identifier: formData.contact,
      otp: value.otp,
      name: formData.name,
      profile_created_for:formData.profileFor,
    };
    if (formData?.Countrycodes && isMobileField) {
      formFields.countrycode = formData.Countrycodes.value;
    }
    if (onSubmit) {
      onSubmit(formFields);
      return;
    }
    verifyOtp(formFields);
  };

  return (
    <Modal
      isOpen={open}
      className="otp-modal-wrapper"
      rootClassName="otp-modal-root"
      onCancel={onCancel}
      title=""
      width={464}
      footer={null}
      closable
    >
      <div className="otp-modal-content">
        <h2 className="font-title-xl">{title}</h2>
        <p className="modal-description mt-2">
          Enter the OTP sent to {isMobileField && formData?.Countrycodes?.label}{" "}
          {formData?.contact}
        </p>
        <Form
          form={form}
          className="login-form mt-8"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            name="otp"
            validateTrigger="onSubmit"
            className="custom-error"
            rules={[
              {
                validator: (_, value) => {
                  if (
                    !value ||
                    value.length !== 6 ||
                    [...value].some((digit) => digit === "")
                  ) {
                    return Promise.reject(
                      new Error("Please enter the complete 6-digits OTP"),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <OtpInput
              id="otp"
              mask="•"
              placeholder={"-".repeat(length)}
              value={otpValue}
              setValue={setOtpValue}
            />
          </Form.Item>
          <div className="mt-4 flex items-center gap-1-5">
            <p className="otp-timer text-sm">Haven’t received the code yet?</p>
            {counter > 0 ? (
              <>
                <span className="timer">{formatTime()}</span>
              </>
            ) : (
              <Button
                isLoading={isResendPending}
                className="resend-btn"
                variant="link"
                onClick={handleResend}
              >
                Resend OTP
              </Button>
            )}
          </div>
          <Button
            isLoading={isOtpPending || isLoading}
            htmlType="submit"
            onClick={() => {
              form.validateFields().catch((err) => {
              });
            }}
            className="mt-8"
            wFull
          >
            Submit
          </Button>
        </Form>
      </div>
    </Modal>
  );
}

export default OtpModal;
